// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media(max-width: 575.98px){.reservation-filter[data-v-51223d2c] .dropdown-menu{height:300px;overflow-y:auto}}", ""]);
// Exports
module.exports = exports;
